import { el } from "../lib/dom";
import { sectionCover } from "../lib/sectionCover";
import { gifts } from "../content/site";
import { photos } from "../content/photos.generated";

export function renderGifts(root: HTMLElement) {
  const page = el("section", { class: "page", id: "geskenke" });

  page.appendChild(
    sectionCover({
      title: "Trougeskenk",
      photo: photos.gallery[18] ?? photos.gallery[0] ?? null,  // IMG_4790
    }),
  );

  const content = el("div", { class: "page__content gifts__content" });

  const card = el(
    "article",
    { class: "gifts__card" },
    el("h3", {}, "Bankbesonderhede"),
    el(
      "dl",
      {},
      el("dt", {}, "Naam"),
      el("dd", {}, gifts.bank.holder),
      el("dt", {}, "Bank"),
      el("dd", {}, gifts.bank.bank),
      el("dt", {}, "Rekeningnommer"),
      el("dd", {}, gifts.bank.account),
    ),
  );

  content.appendChild(card);
  page.appendChild(content);
  root.appendChild(page);
}
